import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { applyTheme, loadTheme } from "./lib/theme.ts";

applyTheme(loadTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary name="VTMS" fullScreen>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
